import $ from 'jquery';
const BASE_SELECTOR: string = '.admin-panel';
const CLOSE_BUTTON_SELECTOR: string = '.close-adminbar';
export class AdminbarUI {
    public constructor(private $base: JQuery) {

    }

    public onCloseButtonClick(callback) {
        $(CLOSE_BUTTON_SELECTOR).on('click', () => {
            callback();
        })
    }

    public destroy() {
        this.$base.remove();
    }
}

export function createAdminbarInstances() {
    const $base = $(BASE_SELECTOR);
    let instances: AdminbarUI[] = new Array();

    $base.each((index, el) => {
        instances.push(new AdminbarUI($(el)));
    });
    return instances;
}
